<template>
  <div>
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <div style="text-align: center;font-size: 20px;">
      <button
        style="width:500px;height:100px;background-color:orange;margin:auto"
        @click="print()"
      >
        طباعة فاتورة شراء بكود
        <br />
        {{ fatwora.code }}
      </button>
    </div>
    <div id="printMe" style="display:none">
      <div style="direction:rtl;float:right">
        <p
          style="text-align:center;font-size:22px;font-weight:bold;margin-bottom:15px;text-decoration:underline;"
        >
          طباعة فاتورة شراء بكود
          {{ fatwora.code }}
        </p>
        <div class="row">
          <div class="col-sm-4" style="border-left:1px dotted">
            <div style="float:right;">
              <img
                style="width:100%;height:100px;"
                src="../../../public/images/pharma_logo.jpg"
                alt="Pharma"
              />
            </div>
          </div>
          <div class="col-sm-8">
            <div style="float:right;font-size:17px;text-align:right">
              <p>
                <span style="font-weight:bold;"> الكود : </span>
                <span> {{ fatwora.code }} </span>
              </p>

              <p>
                <span style="font-weight:bold;"> الكود الورقي : </span>
                <span> {{ fatwora.paper_code }} </span>
              </p>

              <p>
                <span style="font-weight:bold;"> المورد : </span>
                <span> {{ fatwora.importer_name }} </span>
              </p>

              <p>
                <span style="font-weight:bold;"> التاريخ : </span>
                <span> {{ fatwora.created_at }} </span>
              </p>
            </div>
          </div>
        </div>
        <br />
        <hr />
        <hr />
        <br />
        <br />
        <table class="table table-sm table-bordered" style="text-align:center">
          <thead>
            <tr>
              <th scope="col">اسم الصنف</th>
              <th scope="col">العدد</th>
              <th scope="col">سعر الوحدة</th>
              <th scope="col">سعر الوحدات</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in fatwora.fatwora_items" :key="f.id">
              <th scope="row">{{ f.item_name }}</th>

              <td>{{ f.item_num }}</td>
              <td>{{ f.price }}</td>
              <td>{{ f.total_price }}</td>
            </tr>
          </tbody>
        </table>
        <br />
        <hr />
        <br />
        <table
          class="table table-sm table-bordered"
          style="text-align:center; "
        >
          <thead>
            <tr style="border:2px double black;">
              <th scope="col">المجموع قبل الخصم</th>
              <th scope="col">الخصم</th>
              <th scope="col">المجموع بعد الخصم</th>
            </tr>
          </thead>
          <tbody>
            <tr style="border:2px double black;">
              <th scope="row">{{ fatwora.price }}</th>
              <td>{{ fatwora.fatwora_dicount }}</td>
              <td>{{ fatwora.final_price }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { buy_fatwora } from "../config/apiRoute.js";
import { appUrl } from "../config/apiConfig.js";
export default {
  data() {
    return {
      loading: true,
      fatwora: {},
      appUrl: ""
    };
  },
  mounted() {
    this.appUrl = appUrl;
    this.get_data();
  },
  methods: {
    print() {
      this.$htmlToPaper("printMe");
    },
    get_data() {
      buy_fatwora(this.$route.params.id).then(response => {
        this.fatwora = response.data;

        this.loading = false;
        setTimeout(() => {
          this.print();
        }, 200);
      });
    }
  }
};
</script>
